"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { getBreadcrumbItems } from "./utils";

export interface BreadcrumbListItem {
  "@type": "ListItem";
  position: number;
  name: string;
  item: string;
}

interface BreadcrumbListJsonLdProps {
  navData?: any;
  searchParams?: { [key: string]: string | string[] | undefined };
  items?: BreadcrumbListItem[];
}

const BreadcrumbListJsonLd = ({
  navData = [],
  searchParams,
  items,
}: BreadcrumbListJsonLdProps) => {
  const pathname = usePathname();

  const breadcrumbItems = useMemo(() => {
    if (items) return items;
    return getBreadcrumbItems(pathname, searchParams, navData);
  }, [pathname, searchParams, navData, items]);

  if (!breadcrumbItems || breadcrumbItems.length < 2) {
    return null;
  }

  const breadcrumbListJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbItems,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbListJsonLd) }}
    />
  );
};

export default BreadcrumbListJsonLd;
